export default __webpack_public_path__ + "static/media/logoo.8963bf1a.png";